import { Icon } from '../../../layout/Icon.jsx';
import clsx from 'clsx';

export function CategoriesPanel({
  categories = [],
  productsByCategory = {},
  selected,
  onSelect,
  onCreate,
  onEdit,
  canManage
}) {
  return (
    <div className="card">
      <div className="card-h">
        <div className="flex-1">
          <h3 className="text-[14.5px] font-bold">الأقسام</h3>
          <div className="text-xs text-ink-3 mt-0.5">{categories.length} قسم</div>
        </div>
        {canManage ? (
          <button type="button" className="btn" style={{ padding: '6px 12px', fontSize: 12 }} onClick={onCreate}>
            <Icon name="plus" size={14} /> قسم جديد
          </button>
        ) : null}
      </div>
      <div className="card-b">
        <button
          type="button"
          onClick={() => onSelect(null)}
          className={clsx(
            'w-full mb-1.5 px-3 py-2 rounded-[10px] text-[13px] font-semibold border text-start transition-colors flex items-center justify-between',
            !selected
              ? 'bg-orange text-white border-orange'
              : 'bg-white border-line text-ink-2 hover:bg-paper-2'
          )}
        >
          <span>الكل</span>
          <span className="opacity-80 text-[11px]">
            {Object.values(productsByCategory).reduce((s, n) => s + n, 0)}
          </span>
        </button>

        <div className="flex flex-col gap-1.5 max-h-[420px] overflow-y-auto">
          {categories.map((c) => {
            const id = c._id || c.id;
            const active = String(selected) === String(id);
            const count = productsByCategory[id] || 0;
            return (
              <div
                key={id}
                className={clsx(
                  'rounded-[10px] border flex items-center gap-2 px-3 py-2 transition-colors',
                  active ? 'bg-orange-soft border-orange' : 'bg-white border-line hover:bg-paper-2'
                )}
              >
                <button
                  type="button"
                  className="flex items-center gap-2 flex-1 text-start"
                  onClick={() => onSelect(id)}
                >
                  <span
                    className="w-2.5 h-2.5 rounded-full shrink-0"
                    style={{ background: c.color || '#FF7A1A' }}
                  />
                  {c.icon ? <span className="text-[15px]">{c.icon}</span> : null}
                  <span className="font-bold text-[13px] flex-1">{c.name}</span>
                  <span className="text-ink-3 text-[11px]">({count})</span>
                </button>
                {canManage ? (
                  <button
                    type="button"
                    className="text-ink-3 hover:text-ink"
                    onClick={() => onEdit(c)}
                    title="تعديل"
                  >
                    <Icon name="edit" size={12} />
                  </button>
                ) : null}
              </div>
            );
          })}
          {categories.length === 0 ? (
            <div className="text-ink-3 text-center py-6 text-[12.5px]">لا توجد أقسام</div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
